// extracted by mini-css-extract-plugin
export default {"wrapper":"Verification_wrapper__J8yjk","container":"Verification_container__hAhir","HeroSectionWrapper":"Verification_HeroSectionWrapper__+mr28"};